import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import store from '@/store/index';
import {AUTH_CHECK_LOGIN, AUTH_LOGOUT} from '@/store/action-types';

// Containers
//const DefaultContainer = () => import('@/containers/DefaultContainer')
const SimplifiedContainer = () => import('@/containers/SimplifiedContainer')

// Auth
const ComingSoon = () => import('@/pages/auth/ComingSoon')
const TestPage = () => import('@/pages/auth/TestPage')
const Login = () => import('@/pages/auth/Login')
const PasswordReset = () => import('@/pages/auth/PasswordReset')
const PasswordResetChange = () => import('@/pages/auth/PasswordResetChange')
const Register = () => import('@/pages/auth/Register')
const RegisterConfirmation = () => import('@/pages/auth/RegisterConfirmation')
const EmailChangeConfirmation = () => import('@/pages/auth/EmailChangeConfirmation')
const TokenLogin = () => import('@/pages/auth/TokenLogin')

const Dashboard = () => import('@/pages/Dashboard')
const Settings = () => import('@/pages/Settings')

const SubmissionAdd = () => import('@/pages/submissions/SubmissionAdd')
const SubmissionAddSteps = () => import('@/pages/submissions/SubmissionAddSteps')

const CartIndex = () => import('@/pages/cart/CartIndex')
const CartCheckout = () => import('@/pages/cart/CartCheckout')
const CartCheckoutFinalize = () => import('@/pages/cart/CartCheckoutFinalize')

const TeamIndex = () => import('@/pages/team/TeamIndex')
const TeamEdit = () => import('@/pages/team/TeamEdit')
const ProjectIndex = () => import('@/pages/projects/ProjectIndex')
const SampleIndex = () => import('@/pages/samples/SampleIndex')
const SampleDetail = () => import('@/pages/samples/SampleDetail')
const ReportIndex = () => import('@/pages/reports/ReportIndex')

const ResultIndex = () => import('@/pages/results/ResultIndex')
const ResultDetail = () => import('@/pages/results/ResultDetail')
const ResultAnalyteHistory = () => import('@/pages/results/ResultAnalyteHistory')
const ResultTimeSeriesReport = () => import('@/pages/results/ResultTimeSeriesReport')
const ResultAddRecommendation = () => import('@/pages/results/ResultAddRecommendation')
const ResultAddInspection = () => import('@/pages/results/ResultAddInspection')
const ResultEmailResults = () => import('@/pages/results/ResultEmailResults')

const ApiIndex = () => import('@/pages/api/ApiIndex')
const ProductIndex = () => import('@/pages/products/ProductIndex')

const ContactInvite = () => import('@/pages/team/ContactInvite')
const ContactAdd = () => import('@/pages/team/ContactAdd')
const ContactEdit = () => import('@/pages/team/ContactEdit')
const LocationAdd = () => import('@/pages/locations/LocationAdd')
const LocationEdit = () => import('@/pages/locations/LocationEdit')

const CustomerGrowerIndex = () => import('@/pages/customergrower/CustomerGrowerIndex')
const CustomerGrowerDetail = () => import('@/pages/customergrower/CustomerGrowerDetail')
const CustomerGrowerAdd = () => import('@/pages/customergrower/CustomerGrowerAdd')
const CustomerGrowerEdit = () => import('@/pages/customergrower/CustomerGrowerEdit')
const CustomerGrowerTimeSeriesReport = () => import('@/pages/customergrower/CustomerGrowerTimeSeriesReport')

const CustomerFieldAdd = () => import('@/pages/customerfield/CustomerFieldAdd')
const CustomerFieldEdit = () => import('@/pages/customerfield/CustomerFieldEdit')

const CustomerCoordIndex = () => import('@/pages/customercoord/CustomerCoordIndex')
const CustomerCoordDetail = () => import('@/pages/customercoord/CustomerCoordDetail')
const CustomerCoordEdit = () => import('@/pages/customercoord/CustomerCoordEdit')
const CustomerCoordAdd = () => import('@/pages/customercoord/CustomerCoordAdd')

const ProjectDetail = () => import('@/pages/projects/ProjectDetail')
const SubmissionDetail = () => import('@/pages/submissions/SubmissionDetail')
const SubmissionTimeSeriesReport = () => import('@/pages/submissions/SubmissionTimeSeriesReport')

const OrderIndex = () => import('@/pages/orders/OrderIndex')
const OrderDetail = () => import('@/pages/orders/OrderDetail')

const InstructionIndex = () => import('@/pages/instructions/InstructionIndex')
const InstructionDetail = () => import('@/pages/instructions/InstructionDetail')

const TimeSeriesReport = () => import('@/pages/timeseriesreport/TimeSeriesReport')

const ResultSharingIndex = () => import('@/pages/resultsharing/ResultSharingIndex')
const ResultSharingAdd = () => import('@/pages/resultsharing/ResultSharingAdd')
const ResultSharingDetail = () => import('@/pages/resultsharing/ResultSharingDetail')
const ResultSharingEdit = () => import('@/pages/resultsharing/ResultSharingEdit')

const CustomerIntegrationIndex = () => import('@/pages/customerintegration/CustomerIntegrationIndex')
const CustomerIntegrationAdd = () => import('@/pages/customerintegration/CustomerIntegrationAdd.vue')
const CustomerIntegrationEdit = () => import('@/pages/customerintegration/CustomerIntegrationEdit.vue')
const CustomerIntegrationDetail = () => import('@/pages/customerintegration/CustomerIntegrationDetail.vue')

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: SimplifiedContainer,
      children: [
        //:: PUBLIC ROUTES
        {path: 'dashboard', component: Dashboard, meta: { requiresAuth: false }},
        {path: 'settings', component: Settings, meta: { requiresAuth: true }},
        {path: 'login', component: Login, meta: { requiresAuth: false }},
        {path: 'request-password-reset', component: PasswordReset, meta: { requiresAuth: false }},
        {path: 'password/reset-password', component: PasswordResetChange, meta: { requiresAuth: false }},
        {path: 'register', component: Register, meta: { requiresAuth: false }},
        {path: 'confirm-email', component: RegisterConfirmation, meta: { requiresAuth: false }},
        {path: 'confirm-email-change', component: EmailChangeConfirmation, meta: { requiresAuth: false }},
        {path: 'auth/token/:token', component: TokenLogin, meta: { requiresAuth: false }},
        //{path: 'register/confirmation', component: RegisterConfirmation, meta: { requiresAuth: false }},
        //{path: 'register/success', component: RegisterSuccess, meta: { requiresAuth: false }},
        {path: 'submissions/add', component: SubmissionAdd, meta: { requiresAuth: false }},
        {
          path: 'submissions/add/step/:step',
          component: SubmissionAddSteps,
          meta: { requiresAuth: false },
        },
        {path: 'cart', component: CartIndex, meta: { requiresAuth: false }},
        {path: 'cart/checkout', component: CartCheckout, meta: { requiresAuth: false }},
        {path: 'products', component: ProductIndex, meta: { requiresAuth: false }},
        {path: 'instructions', component: InstructionIndex, meta: { requiresAuth: false }},
        {path: 'instructions/:id', component: InstructionDetail, meta: { requiresAuth: false }},
        {path: 'test', component: TestPage, meta: { requiresAuth: false }},
        //:: REQUIRES AUTH
        {
          path: 'team',
          component: {render(c){return c('router-view')}},
          meta: { requiresAuth: true },
          redirect: 'team',
          children: [
            {path: '', component: TeamIndex, meta: { requiresAuth: true }},
            {path: 'edit', component: TeamEdit, meta: { requiresAuth: true }},
            {path: 'invite', redirect: '/contacts/invite'},
            {path: ':id', redirect: '/contacts/:id'},
            {path: '*', redirect: '/team'},
          ]
        },
        {
          path: 'contacts',
          component: {render(c){return c('router-view')}},
          meta: { requiresAuth: true },
          redirect: 'team',
          children: [
            {path: 'add', component: ContactAdd, meta: { requiresAuth: true }},
            {path: 'invite', component: ContactInvite, meta: { requiresAuth: true }},
            {path: ':id', component: ContactEdit, meta: { requiresAuth: true }},
            {path: '*', redirect: '/team'},
          ]
        },
        {
          path: 'locations',
          component: {render(c){return c('router-view')}},
          meta: { requiresAuth: true },
          redirect: 'team',
          children: [
            {path: 'add', component: LocationAdd, meta: { requiresAuth: true }},
            {path: ':id', component: LocationEdit, meta: { requiresAuth: true }},
          ]
        },
        {
          path: 'customer-growers',
          component: {render(c){return c('router-view')}},
          meta: { requiresAuth: true },
          redirect: 'customer-growers',
          children: [
            {path: '', component: CustomerGrowerIndex, meta: { requiresAuth: true }},
            {path: 'add', component: CustomerGrowerAdd, meta: { requiresAuth: true }},
            {
              path: ':id',
              component: {render(c){return c('router-view')}},
              meta: { requiresAuth: true },
              redirect: ':id',
              children: [
                {path: '', component: CustomerGrowerDetail, meta: { requiresAuth: true }},
                {path: 'edit', component: CustomerGrowerEdit, meta: { requiresAuth: true }},
                {path: 'time-series-report', component: CustomerGrowerTimeSeriesReport, meta: { requiresAuth: true }},
                {
                  path: 'fields',
                  component: {render(c){return c('router-view')}},
                  meta: { requiresAuth: true },
                  redirect: 'fields',
                  children: [
                    {path: 'add', component: CustomerFieldAdd, meta: { requiresAuth: true }},
                    {
                      path: ':field_id',
                      component: {render(c){return c('router-view')}},
                      meta: { requiresAuth: true },
                      redirect: ':field_id',
                      children: [
                        {path: 'edit', component: CustomerFieldEdit, meta: { requiresAuth: true }},
                      ]
                    },
                    {path: '*', redirect: '/customer-growers/:id'},
                  ]
                },
              ]
            },
          ]
        },
        {
          path: 'projects',
          component: {render(c){return c('router-view')}},
          meta: { requiresAuth: true },
          redirect: 'projects',
          children: [
            {path: '', component: ProjectIndex, meta: { requiresAuth: true }},
            {path: ':project_id', component: ProjectDetail, meta: { requiresAuth: true }, props: true},
          ]
        },
        //{path: 'contacts/add', component: ContactAdd, meta: { requiresAuth: true }},
        //{path: 'contacts/:id', component: ContactEdit, meta: { requiresAuth: true }},
        //{path: 'locations/add', component: LocationAdd, meta: { requiresAuth: true }},
        //{path: 'locations/:id', component: LocationEdit, meta: { requiresAuth: true }},
        //{path: 'projects', component: ProjectIndex, meta: { requiresAuth: true }},
        //{path: 'projects/:id', component: ProjectDetail, meta: { requiresAuth: true }},
        {path: 'samples', component: SampleIndex, meta: { requiresAuth: true }},
        {path: 'samples/:id', component: SampleDetail, meta: { requiresAuth: true }},
        {path: 'submissions/:id', component: SubmissionDetail, meta: { requiresAuth: true }},
        {path: 'submissions/:id/time-series-report', component: SubmissionTimeSeriesReport, meta: { requiresAuth: true }},
        {path: 'orders', component: OrderIndex, meta: { requiresAuth: true }},
        {path: 'orders/:id', component: OrderDetail, meta: { requiresAuth: true }},
        {path: 'reports', component: ReportIndex, meta: { requiresAuth: true }},
        {path: 'results', component: ResultIndex, meta: { requiresAuth: true }},
        {path: 'results/:id', component: ResultDetail, meta: { requiresAuth: true }},
        {path: 'results/:id/time-series-report', component: ResultTimeSeriesReport, meta: { requiresAuth: true }},
        {path: 'results/:id/add-recommendation', component: ResultAddRecommendation, meta: { requiresAuth: true }},
        {path: 'results/:id/add-inspection', component: ResultAddInspection, meta: { requiresAuth: true }},
        {path: 'results/:id/email-results', component: ResultEmailResults, meta: { requiresAuth: true }},
        {path: 'results/:id/:sample_result_id', component: ResultAnalyteHistory, meta: { requiresAuth: true }},
        {path: 'api', component: ApiIndex, meta: { requiresAuth: true }},
        {path: 'settings', component: ComingSoon, meta: { requiresAuth: true }},
        {path: 'cart/checkout/finalize', component: CartCheckoutFinalize, meta: { requiresAuth: false }},
        {path: 'time-series-report', component: TimeSeriesReport, meta: { requiresAuth: true }},
        {path: 'results-sharing', component: ResultSharingIndex, meta: { requiresAuth: true }},
        {path: 'results-sharing/add', component: ResultSharingAdd, meta: { requiresAuth: true }},
        {path: 'results-sharing/:id', component: ResultSharingDetail, meta: { requiresAuth: true }},
        {path: 'results-sharing/:id/edit', component: ResultSharingEdit, meta: { requiresAuth: true }},
        {path: 'customer-integration', name: 'CustomerIntegration', component: CustomerIntegrationIndex, meta: { requiresAuth: true }},
        {path: 'customer-integration/add', name: 'CustomerIntegrationAdd', component: CustomerIntegrationAdd, meta: { requiresAuth: true }},
        {path: 'customer-integration/:id', name: 'CustomerIntegrationDetail', component: CustomerIntegrationDetail, meta: { requiresAuth: true }},
        {path: 'customer-integration/:id/edit', name: 'CustomerIntegrationEdit', component: CustomerIntegrationEdit, meta: { requiresAuth: true }},
        {path: 'customer-coords', component: CustomerCoordIndex, meta: { requiresAuth: true }},
        {path: 'customer-coords/add', component: CustomerCoordAdd, meta: { requiresAuth: true }},
        {path: 'customer-coords/:id', component: CustomerCoordDetail, meta: { requiresAuth: true }},
        {path: 'customer-coords/:id/edit', component: CustomerCoordEdit, meta: { requiresAuth: true }},
      ]
    }
      /*path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        //:: REQUIRES AUTH
        {path: 'dashboard', component: ComingSoon, meta: { requiresAuth: true }},
        {path: 'submissions', component: ComingSoon, meta: { requiresAuth: true }},
        {path: 'results', component: ComingSoon, meta: { requiresAuth: true }},
        {path: 'settings', component: ComingSoon, meta: { requiresAuth: true }},
        {path: 'dashboard', component: ComingSoon, meta: { requiresAuth: true }},
        //:: PUBLIC ROUTES
        {path: 'login', component: Login, meta: { requiresAuth: false }},
        {path: 'register', component: Register, meta: { requiresAuth: false }},
        {path: 'register/confirmation', component: RegisterConfirmation, meta: { requiresAuth: false }},
        {path: 'register/success', component: RegisterSuccess, meta: { requiresAuth: false }},
        {path: 'submissions/add', component: SubmissionAdd, meta: { requiresAuth: false }},
        {
          path: 'submissions/add/step/:step',
          component: SubmissionAddSteps,
          meta: { requiresAuth: false },
        },
        {path: 'cart', component: CartIndex, meta: { requiresAuth: false }},
      ]
    },*/
  ]
})

// router.beforeResolve(async (to, from, next) => {
//   let auth_check = false;
//   try {
//     await store.dispatch(AUTH_CHECK_LOGIN);
//     auth_check = true;
//   } catch (e) {
//     await store.dispatch(AUTH_LOGOUT, {});
//     auth_check = false;
//   }
//
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     if(auth_check) {
//       next();
//     } else {
//       next({
//         path: "/login",
//         query: {
//           redirect: to.fullPath
//         }
//       });
//     }
//     // try {
//     //   await store.dispatch(AUTH_CHECK_LOGIN);
//     //   next();
//     // } catch (e) {
//     //   next({
//     //     path: "/login",
//     //     query: {
//     //       redirect: to.fullPath
//     //     }
//     //   });
//     // }
//   } else {
//     next();
//   }
// });

router.beforeResolve(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    try {
      await store.dispatch(AUTH_CHECK_LOGIN)
      next()
    } catch (e) {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else next()
});

export default router;
